<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="h_zp_zx" style="margin-top:0;">
      <div class="banner">
        <el-carousel indicator-position="none" :interval="5000" arrow="always" height="500px">
          <el-carousel-item>
            <img src="../../assets/energy/1667303170833444.jpg" alt="致力于保护全球环境和人类健康" width="100%">
            <div class="banner_zj">
              <h2>致力于保护全球环境和人类健康</h2>
              <div class="active">
                <p>丰富的行业经验，上万家客户口碑，一站式贴心服务</p>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/energy/1667304271431790.jpg" alt="致力于保护全球环境和人类健康" width="100%">
            <div class="banner_zj">
              <h2>致力于保护全球环境和人类健康</h2>
              <div class="active">
                <p>丰富的行业经验，上万家客户口碑，一站式贴心服务</p>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/energy/1667304281872204.jpg" alt="致力于保护全球环境和人类健康" width="100%">
            <div class="banner_zj">
              <h2>致力于保护全球环境和人类健康</h2>
              <div class="active">
                <p>丰富的行业经验，上万家客户口碑，一站式贴心服务</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="companies">
        <div class="companies_top">
          <div>
            <p>
              <img src="../../assets/energy/sy_dd.png" alt="关于我们" width="41" height="43">
            </p>
            <h3>关于我们</h3>
            <div class="active">
              在公司出现以前，个人独资企业是最典型的企业形式；与独资企业并存的是各种合伙组织，当时的合伙组织中最典型的就是家族经营团体。在公司产生以前，合伙组织都没有取得法人的地位，但是却有其他的一些法人团体出现。这种情况最早可以追溯至古罗马时期。在古罗马，国家、地方自治团体、寺院等宗教团体、养老院等公益慈善团体都取得了法人的地位。到了中世纪，有一些贸易团体取得了法人的资格，尤其是其中从事海外贸易的组织。在中世纪英国，这样的组织享有相对合伙更大的独立性。在市场经济中，与其他市场主体相比，公司有以下优点：市场经济要求平等的市场主体按照等价交换的原则；通过公平竞争，从市场取得和向市场提供商品，促进整个市场合理流...
            </div>
            <p class="button">
              <router-link :to="{path:'/'}">了解更多</router-link>
            </p>
          </div>
        </div>
        <div class="companies_bottom">
          <ul class="clearfix">
            <div>
              <ul>
                <li>
                  <div class="companies_img">
                    <img src="../../assets/energy/sy_jzg.png" alt="价值观">
                  </div>
                  <h4>价值观</h4>
                  <p class="li_p">“责任、卓越、进取、分享”是百度的核心价值观。</p>
                </li>
                <li>
                  <div class="companies_img">
                    <img src="../../assets/energy/sy_shzr.png" alt="社会责任">
                  </div>
                  <h4>社会责任</h4>
                  <p class="li_p">勇担责任，坚守商业及职业道德，恪尽社会责任。</p>
                </li>
                <li>
                  <div class="companies_img">
                    <img src="../../assets/energy/sy_yjcx.png" alt="研发创新">
                  </div>
                  <h4>研发创新</h4>
                  <p class="li_p">矢志创新，开展创新活动，为公司创造可持续性价值。</p>
                </li>
              </ul>
            </div>
          </ul>
        </div>
        <div class="system">
          <ul class="clearfix">
            <li class="clearfix">
              <div class="layout-area">
                <div class="system_img11"></div>
                <div class="system_li system_li3">
                  <h4>测试信息行业</h4>
                  <div class="system_p">
                    应用产品：自动补水装置自动软化水装置微泡排气装置微米级除污装置加药装置扩容罐压力膨胀罐温度缓冲罐核心技术点：（1）高温液体将直接挑战设备安全（2）水质条件恶劣对于系统的影响（3）压力稳定对于系统的重要性（···
                  </div>
                  <p class="button">
                    <router-link :to="{path:'/'}">了解更多</router-link>
                  </p>
                </div>
              </div>
            </li>
            <li class="clearfix">
              <div class="layout-area">
                <div class="system_img12"></div>
                <div class="system_li system_li3">
                  <h4>测试信息行业</h4>
                  <div class="system_p">
                    应用产品：自动补水装置自动软化水装置微泡排气装置微米级除污装置加药装置扩容罐压力膨胀罐温度缓冲罐核心技术点：（1）高温液体将直接挑战设备安全（2）水质条件恶劣对于系统的影响（3）压力稳定对于系统的重要性（···
                  </div>
                  <p class="button">
                    <router-link :to="{path:'/'}">了解更多</router-link>
                  </p>
                </div>
              </div>
            </li>
            <li class="clearfix">
              <div class="layout-area">
                <div class="system_img13"></div>
                <div class="system_li system_li3">
                  <h4>测试信息行业</h4>
                  <div class="system_p">
                    应用产品：自动补水装置自动软化水装置微泡排气装置微米级除污装置加药装置扩容罐压力膨胀罐温度缓冲罐核心技术点：（1）高温液体将直接挑战设备安全（2）水质条件恶劣对于系统的影响（3）压力稳定对于系统的重要性（···
                  </div>
                  <p class="button">
                    <router-link :to="{path:'/'}">了解更多</router-link>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="products">
          <div class="products_top">
            <div class="layout-area">
              <p>
                <img src="../../assets/energy/sy_zy.png" alt="" width="39" height="39">
              </p>
              <h3>产品中心</h3>
            </div>
          </div>
          <div class="products_bottom">
            <ul class="clearfix">
              <li>
                <router-link :to="{path:'/'}">
                  <div class="li_img">
                    <p>
                      <img src="../../assets/energy/1667305372787783.jpg" alt="栏目一类">
                    </p>
                  </div>
                  <div class="li_div">
                    <h4>栏目一类</h4>
                    <p class="products_p">环保，全称环境保护，是指人类为解决现实的或潜在的环境问题，协调人类与环境的关系，保障经济、社会的持续发展而采取的各种行动的总称。其方法和手段有工程技术的、行政管···</p>
                    <p class="button">了解更多</p>
                  </div>
                </router-link>
              </li>
              <li>
                <router-link :to="{path:'/'}">
                  <div class="li_img">
                    <p>
                      <img src="../../assets/energy/1667305381156854.jpg" alt="栏目二类">
                    </p>
                  </div>
                  <div class="li_div">
                    <h4>栏目二类</h4>
                    <p class="products_p">环保，全称环境保护，是指人类为解决现实的或潜在的环境问题，协调人类与环境的关系，保障经济、社会的持续发展而采取的各种行动的总称。其方法和手段有工程技术的、行政管···</p>
                    <p class="button">了解更多</p>
                  </div>
                </router-link>
              </li>
              <li>
                <router-link :to="{path:'/'}">
                  <div class="li_img">
                    <p>
                      <img src="../../assets/energy/1667305396456248.jpg" alt="栏目三类">
                    </p>
                  </div>
                  <div class="li_div">
                    <h4>栏目三类</h4>
                    <p class="products_p">环保，全称环境保护，是指人类为解决现实的或潜在的环境问题，协调人类与环境的关系，保障经济、社会的持续发展而采取的各种行动的总称。其方法和手段有工程技术的、行政管···</p>
                    <p class="button">了解更多</p>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Repair',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      qyloading: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.banner {
  width: 1200px;
  height: 500px;
  margin: 0 auto;
}
.banner_zj {
  width: 1200px;
  z-index: 1;
  position: absolute;
  top: 200px;
  left: 50%;
  margin-left: -600px;
  color: #fff;
  text-align: center;
}
.banner_zj h2 {
  font-size: 30px;
  font-weight: bold;
  color: #ffffff;
}
.banner_zj .active {
  padding: 30px 300px 0;
  font-size: 14px;
  line-height: 24px;
  background: url(../../assets/energy/banner_bj_xian.png) no-repeat center top;
  margin-top: 30px;
}
.companies {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.companies_top {
  width: 100%;
  text-align: center;
  padding-top: 80px;
}
.companies_top h3 {
  font-size: 28px;
  color: #1f2227;
}
.companies_top .active {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  padding: 75px 150px 50px;
  text-align: left;
}
.companies .button {
  margin: 0 auto;
}
.button {
  width: 142px;
  height: 42px;
  border: 1px solid #5178b5;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #5178b5;
  line-height: 42px;
}
.button a {
  display: inline-block;
  width: 142px;
  height: 42px;
  font-size: 14px;
  font-weight: bold;
  color: #5178b5;
  line-height: 42px;
}
.button a:hover {
  width: 142px;
  height: 42px;
  background: #5178b5;
  color: #fff;
}
.companies_bottom {
  width: 100%;
  margin-top: 70px;
  margin-bottom: 80px;
}
.companies_bottom ul {
  width: 100%;
}
.companies_bottom ul li {
  float: left;
  width: 33.333333%;
  text-align: center;
  margin: 0 0px;
}
.companies_bottom .companies_img {
  max-width: 180px;
  margin: 0 auto;
  width: 100%;
}
.companies_bottom .companies_img img {
  width: 100%;
}
.companies_bottom ul li h4 {
  font-size: 20px;
  color: #333333;
  margin-top: 15px;
}
.companies_bottom .li_p {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  padding: 0 10px;
  background: url(../../assets/energy/img_xian.png) no-repeat center top;
  padding-top: 30px;
  margin-top: 5px;
}
.system {
  width: 100%;
  max-width: 1920px;
  background: #f5f3f0;
}
.system ul {
  width: 100%;
}
.system ul li {
  float: left;
  width: 100%;
  overflow: hidden;
  margin: 0px 0px;
}
.system_img11 {
  float: left;
  width: 50%;
  height: 470px;
  background: url(../../assets/energy/1667288367102647.jpg) no-repeat center;
  background-size: cover;
}
.system_img12 {
  float: right;
  width: 50%;
  height: 470px;
  background: url(../../assets/energy/1667288307843811.jpg) no-repeat center;
  background-size: cover;
}
.system_img13 {
  float: left;
  width: 50%;
  height: 470px;
  background: url(../../assets/energy/1667288149957555.jpg) no-repeat center;
  background-size: cover;
}
.system_li {
  float: left;
  width: 50%;
  padding-top: 4%;
}
.system_li3 {
  width: 40%!important;
  padding-left: 6%;
  padding-right: 4%;
}
.system h4 {
  font-size: 20px;
  color: #333;
  width: 190px;
  padding-bottom: 15px;
  border-bottom: 5px solid #5178b5;
}
.system_p {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  margin-top: 5%;
  height: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.system .button {
  margin-top: 7%;
}
.button a {
  display: inline-block;
  width: 142px;
  height: 42px;
  font-size: 14px;
  font-weight: bold;
  color: #5178b5;
  line-height: 42px;
}
.products {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
}
.products_top {
  width: 100%;
  text-align: center;
}
.products_top h3 {
  font-size: 28px;
  color: #1f2227;
}
.products_bottom {
  margin-top: 50px;
}
.products_bottom ul {
  display: inline-block;
  margin: 0 -1%;
  width: 100%;
}
.products_bottom ul li {
  float: left;
  width: 31.333333%;
  margin: 0 1%;
  background: #f4f4f4;
}
.products_bottom .li_img {
  width: 100%;
}
.products_bottom .li_img img {
  width: 100%;
}
.products_bottom .li_div {
  padding: 0 20px;
  text-align: center;
}
.products_bottom .li_div h4 {
  font-size: 20px;
  color: #333333;
  margin-top: 15px;
}
.products_bottom .li_div h4+p {
  font-size: 14px;
  color: #999999;
}
.products_bottom .products_p {
  margin-top: 15px;
  font-size: 12px;
  color: #666;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  text-align: left;
  height: 120px;
}
.products_bottom .button {
  margin: 30px auto;
}
.button:hover {
  border: 1px solid #5178b5;
  background: #5178b5;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/energy/index.vue